import React from 'react';
import {Button, Heading, Table} from 'arag-ui-lib';
import { useHistory } from 'react-router-dom';

const columns = [
    {
        propertyName: 'medicalName',
        header: 'Medical Name',
        id: 'medicalName',
        sortable: false,
    },
    {
        propertyName: 'brandName',
        header: 'Brand Name',
        id: 'brandName',
        sortable: false,
    },
];

const Products = (props) => {
    const {loading, products, handleDelete} = props;
    let history = useHistory();

    return (
        <div>
            <Heading variant="h2" title="Products"/>
            <div className={'form-group'}>
                <Button
                    variant="primary"
                    label="Create New Product"
                    arrowDirection="right"
                    onClick={() => {
                        history.push('/new-product');
                    }}
                />
            </div>
            <Table
                loading={loading}
                striped
                columns={columns}
                data={products}
                hasActions
                actions={
                    [
                        {
                            key: 'edit',
                            label: 'Edit',
                            callback: (datum) =>  history.push(`/products/${datum.medicalName}`),
                        },
                        {
                            key: 'delete',
                            label: 'Delete',
                            callback: (datum) =>  handleDelete(datum.medicalName),
                        },
                    ]
                }
                // accordionItemHeaderFormatter={AccordionHeader}
                // pageSize={pager.limit}
                // totalRecords={pager.count || 0}
                // totalPages={pager.totalPages || 0}
                // page={pager.page}
                // pageSizeOptions={config.listSizeOptions}
                // goAtPrevious={goAtPrevious}
                // goAtNext={goAtNext}
                // goAtStart={goAtStart}
                // goAtEnd={goAtEnd}
                // goAtPage={goAtPage}
                // onPageSizeChange={onPageSizeChange}
            />
        </div>
    );
};

export default Products;